import { render, staticRenderFns } from "./centerLeft1.vue?vue&type=template&id=4c32720d&"
import script from "./centerLeft1.vue?vue&type=script&lang=js&"
export * from "./centerLeft1.vue?vue&type=script&lang=js&"
import style0 from "./centerLeft1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports